// A cycle year that has not been created has no Revisions map. Indexing it
// with a missing RevisionID throws `reading 'undefined'`.

export function cycleRevisionRecord(cycleRecord) {
    const revisions = cycleRecord?.Revisions;
    if (revisions == null) return undefined;
    return revisions[cycleRecord.RevisionID];
}

export function describedRevisions(cycleRevisions) {
    return Object.values(cycleRevisions?.Revisions || {}).filter((rev) => !!rev?.Date && !!rev?.Description);
}
